// /src/pages/ImoveisPublicosView.jsx (Recomendado renomear para PlanosPublicosView futuramente)
// VERSÃO 7.1 SUPREMA - TIM UNITY PUBLIC VITRINE

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import apiClient from '../api/apiClient';
import ImovelCard from '../components/imovel/ImovelCard'; 
import { 
    FiSearch, FiGlobe, FiChevronRight, FiLoader, FiZap, FiArrowLeft 
} from 'react-icons/fi';
import { motion, AnimatePresence } from 'framer-motion';

export default function ImoveisPublicosView() {
    const navigate = useNavigate();
    const [imoveis, setImoveis] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [filtroTipo, setFiltroTipo] = useState("");
    const [busca, setBusca] = useState("");

    useEffect(() => {
        const load = async () => {
            try {
                const res = await apiClient.get('/api/filtros/busca?status=Aprovado');
                setImoveis(Array.isArray(res.data) ? res.data : []);
            } catch (e) { 
                console.error("💥 Falha no uplink da vitrine:", e); 
            } finally { setIsLoading(false); }
        };
        load();
    }, []);

    const destaquePrincipal = imoveis.find(i => i.isDestaque) || imoveis[0];

    const imoveisFiltrados = imoveis.filter(imo => {
        const matchBusca = (imo.titulo?.toLowerCase().includes(busca.toLowerCase())) || 
                           (imo.nivelCobertura?.toLowerCase().includes(busca.toLowerCase())) ||
                           (imo.codigoImovel?.toLowerCase().includes(busca.toLowerCase()));
        
        const matchTipo = filtroTipo === "" || imo.tipoPrincipal === filtroTipo;
        return matchBusca && matchTipo;
    });

    if (isLoading) return (
        <div className="h-screen w-full flex flex-col items-center justify-center" style={{ backgroundColor: 'var(--bg-main)' }}>
            <div className="relative mb-6">
                <FiLoader className="animate-spin text-accent" size={60} />
                <FiZap className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-accent animate-pulse" size={24} />
            </div>
            <span className="text-auto text-[10px] font-black uppercase tracking-[0.5em] opacity-40">Sincronizando Ofertas TIM...</span>
        </div>
    );

    return (
        <div className="min-h-screen transition-colors duration-500 overflow-x-hidden" style={{ backgroundColor: 'var(--bg-main)' }}>
            
            {/* 1. BANNER DE IMPACTO (CINEMATIC) */}
            {destaquePrincipal && (
                <section className="relative h-[75vh] w-full flex items-end pb-24 overflow-hidden bg-black">
                    <motion.img 
                        initial={{ scale: 1.1, opacity: 0 }}
                        animate={{ scale: 1, opacity: 0.6 }}
                        transition={{ duration: 2 }}
                        src={destaquePrincipal.imagensDestaque?.[0] || 'https://via.placeholder.com/1920x1080?text=TIM+UNITY'} 
                        className="absolute inset-0 w-full h-full object-cover"
                        alt="Plano Destaque TIM" 
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[var(--bg-main)] via-transparent to-transparent" />
                    
                    <div className="container mx-auto px-8 md:px-16 relative z-10">
                        <motion.div initial={{ opacity: 0, x: -40 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.5 }} className="max-w-4xl space-y-6">
                            <span className="px-4 py-1.5 rounded-lg bg-accent text-black font-black text-[9px] uppercase tracking-[0.3em]">Oferta Exclusiva</span>
                            <h1 className="text-white drop-shadow-2xl leading-[0.85] tracking-tighter text-5xl md:text-7xl">
                                {destaquePrincipal.titulo}
                            </h1>
                            <p className="text-white/70 font-bold flex items-center gap-3 uppercase text-[10px] tracking-[0.4em]">
                                <FiGlobe className="text-accent" /> 
                                COBERTURA: {destaquePrincipal.nivelCobertura || 'Brasil'} 
                                {destaquePrincipal.nivelCobertura === 'Cidades' ? ` (${destaquePrincipal.localizacao?.cidade || destaquePrincipal.cidade})` : ''}
                            </p>
                            <button 
                                onClick={() => navigate(`/imovel/${destaquePrincipal._id}`)}
                                className="px-12 py-5 bg-white text-black font-black uppercase text-[10px] tracking-[0.4em] hover:bg-[var(--accent-color)] transition-all flex items-center gap-4 shadow-2xl"
                            >
                                Inspecionar Oferta <FiChevronRight />
                            </button>
                        </motion.div>
                    </div>
                </section>
            )}

            {/* 2. DOCK DE BUSCA TÁTICA (STICKY) COM BOTÃO VOLTAR */}
            <div className="sticky top-0 z-[100] border-b backdrop-blur-2xl py-6 shadow-2xl border-[var(--border-color)]" 
                 style={{ backgroundColor: 'var(--bg-main)' }}>
                <div className="container mx-auto px-8 md:px-16 flex flex-col md:flex-row items-center gap-6">
                    
                    {/* BOTÃO VOLTAR */}
                    <button 
                        onClick={() => navigate(-1)}
                        className="hidden md:flex p-5 rounded-[1.5rem] bg-[var(--bg-card)] text-auto hover:text-accent transition-all shadow-lg border border-[var(--border-color)] group"
                        title="Voltar"
                    >
                        <FiArrowLeft size={20} className="group-hover:-translate-x-1 transition-transform" />
                    </button>

                    <div className="relative flex-1 w-full group">
                        <FiSearch className="absolute left-6 top-1/2 -translate-y-1/2 text-accent opacity-30 group-focus-within:opacity-100 transition-opacity" size={20} />
                        <input 
                            type="text" 
                            placeholder="Pesquisar Planos (Ex: Nacional, PR, 50GB)..." 
                            className="w-full pl-16 pr-8 py-5 rounded-[1.5rem] border-none text-sm font-bold focus:ring-2 focus:ring-[var(--accent-color)] transition-all outline-none bg-[var(--bg-card)] text-auto shadow-inner"
                            onChange={(e) => setBusca(e.target.value)}
                        />
                    </div>

                    <div className="flex gap-4 w-full md:w-auto">
                        <select 
                            className="flex-1 md:w-64 px-8 py-5 rounded-[1.5rem] text-[10px] font-black uppercase tracking-widest border-none cursor-pointer bg-[var(--bg-card)] text-auto outline-none focus:ring-2 focus:ring-accent shadow-lg"
                            onChange={(e) => setFiltroTipo(e.target.value)}
                        >
                            <option value="">Todos os Públicos</option>
                            <option value="CPF">Pessoa Física (CPF)</option>
                            <option value="CNPJ">Corporativo (CNPJ)</option>
                        </select>
                    </div>
                </div>
            </div>

            {/* 3. GRID DE INVENTÁRIO */}
            <main className="container mx-auto px-8 md:px-16 py-20">
                <div className="flex flex-col md:flex-row md:items-center gap-6 mb-16 border-l-4 border-accent pl-8">
                    <h2 className="text-auto leading-none text-4xl font-black uppercase tracking-tighter">
                        Ofertas <span className="text-accent">Disponíveis</span>
                    </h2>
                    <span className="w-fit px-4 py-1.5 rounded-full bg-card-auto border border-auto text-[10px] font-black opacity-40 uppercase">
                        {imoveisFiltrados.length} Planos Encontrados
                    </span>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-12">
                    <AnimatePresence mode='popLayout'>
                        {imoveisFiltrados.map((imo) => (
                            <motion.div 
                                layout 
                                initial={{ opacity: 0, scale: 0.9 }} 
                                animate={{ opacity: 1, scale: 1 }} 
                                exit={{ opacity: 0, scale: 0.9 }}
                                key={imo._id}
                            >
                                <ImovelCard 
                                    imovel={imo} 
                                    isPublic={true}
                                    onAction={(id) => navigate(`/imovel/${id}`)} 
                                />
                            </motion.div>
                        ))}
                    </AnimatePresence>
                </div>

                {imoveisFiltrados.length === 0 && (
                    <div className="py-40 text-center">
                        <p className="text-auto opacity-20 font-black uppercase tracking-[1em]">Nenhuma oferta no radar</p>
                    </div>
                )}
            </main>

            <footer className="py-24 text-center border-t border-[var(--border-color)]">
                <p className="text-[10px] font-black uppercase tracking-[1.5em] opacity-10 text-auto">
                    TIM UNITY ENGINE // EXCELLENCE PROTOCOL V11
                </p>
            </footer>
        </div>
    );
}